import { useEffect, useState } from 'react';
import { db } from "@react-native-firebase/database";
import { get, ref, set } from "firebase/database";
import StyleSheetRW from 'core/StyleSheetRW';
import { Dimensions, ScrollView, Text, TextInput, TouchableOpacity, View } from 'react-native';
import { MOBILE_VIEW_WIDTH } from "res/constants";
import DateField from 'src/components/DateField';
import DropDownField from 'src/components/DropDownField';
import { DropDownOptionsCities, DropDownOptionsGenders } from 'src/utils/DropDownOptionsUtils';
import Menu from './Menu';
import { getLocalStorageItem } from 'core/helpers';
import Dialog from 'src/components/Dialog';
import Loader from 'src/components/Loader';
import { getCurrentUserId } from './UserDetailsScreen';

const AdminEditUserProfileScreen= () => {

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    gender: '',
    email:'',
    DOB: '',
    phone: '',
    nextToKin: {
      name: '',
      relation: '',
      contact: '',
    },
  });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  const handleChange = (name: any, value: any) => {
    if (name.includes('nextToKin')) {
      const nextOfKinField = name.split('.')[1];
      setFormData({
        ...formData,
        nextToKin: {
          ...formData.nextToKin,
          [nextOfKinField]: value,
        },
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const screenWidth = Dimensions.get('window').width;
  const loggedinUser = getLocalStorageItem("loggedinUser");

  const handleSubmit = async () => {
    setShowLoader(true)
    if (loggedinUser) {
      const allFieldsFilled = Object.entries(formData).every(([key, value]) => {
        if (key === 'phone') {
          if (value === '') {
            return Object.values(formData.nextToKin).every(nextToKinValue => nextToKinValue !== '');
          } else {
            return true;
          }
        }
        return value !== '';
      });

      if (!allFieldsFilled) {
        setShowLoader(false)
        setShowToast(true);
        setToastMessage("Please fill in all required fields.");
        return;
      }

      const dbRef = ref(db, `profile/${getCurrentUserId()}`);
      await set(dbRef, formData)
        .then(() => {
          setShowLoader(false)
          setShowToast(true);
          setToastMessage("Profile updated successfully");
        })
        .catch((error) => {
          setShowLoader(false)
          console.error("Error updating profile:", error);
          setShowToast(true);
          setToastMessage(`Error updating profile: ${error}`);
        });
    }
  };

  useEffect(() => {
   // setShowLoader(true)
    const fetchUserData = async () => {
      if (loggedinUser) {
        const dbRef = ref(db, `profile/${getCurrentUserId()}`);
        const snapshot = await get(dbRef);
        if (snapshot.exists()) {
          setShowLoader(false)
          setFormData(snapshot.val());
          console.log(snapshot.val())
        } else {
          setShowLoader(false)
        }
      }
    };

  // setUserEmail("dev0352@yopmail.com");

   fetchUserData();
  }, []);


  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100%', overflow: "hidden" }}>
  
      <Menu backEnabled={true} />
      
      <View style={styles.container}>
        <ScrollView showsVerticalScrollIndicator={false} showsHorizontalScrollIndicator={false} style={{ padding: 20, width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "80%" }}>
          <View style={styles.header}>
            <Text style= {screenWidth>=MOBILE_VIEW_WIDTH?styles.heading:{...styles.heading,width:'100%',textAlign:'center',marginTop:-5}}>Profile</Text>
            {screenWidth > MOBILE_VIEW_WIDTH && (
              <TouchableOpacity style={styles.button} onPress={handleSubmit}>
                <Text style={styles.buttonText}>Save Changes</Text>
              </TouchableOpacity>
            )}
          </View>
          <View style={styles.form}>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>First Name</Text>
                <TextInput
                  style={styles.input}
                  placeholder="First Name"
                  value={formData.firstName}
                  onChangeText={(text) => handleChange('firstName', text)}
                />
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Last Name</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChangeText={(text) => handleChange('lastName', text)}
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Address</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Address"
                  value={formData.address}
                  onChangeText={(text) => handleChange('address', text)}
                />
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>City</Text>
                <DropDownField
                  value={formData.city}
                  placeholder="Please Select a City"
                  bodyStyle={{ marginHorizontal: 0 }}
                  options={DropDownOptionsCities}
                  onChangeText={(text) => handleChange('city', text)}
                  label="City"
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Gender</Text>
                <DropDownField
                  value={formData.gender}
                  placeholder="Gender"
                  bodyStyle={{ marginHorizontal: 0 }}
                  options={DropDownOptionsGenders}
                  onChangeText={(text) => handleChange('gender', text)}
                  label="Gender"
                />
              </View>
              <View style={{ ...styles.inputContainer, paddingRight: screenWidth < MOBILE_VIEW_WIDTH ? "10px" : "" }}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Date of Birth</Text>
                <DateField
                  value={formData.DOB}
                  placeholder="MM-DD-YYYY"
                  onChangeText={(text) => handleChange('DOB', text)}
                  label=''
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 0 }}>Phone</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Phone"
                  value={formData.phone}
                  onChangeText={(text) => handleChange('phone', text)}
                />
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 0 }}>Email</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Email"
                  value={formData.email?formData.email:''}
                  editable={false}
                />
              </View>
            </View>
            <View style={[styles.row, { flexDirection: 'row', }]}>
              <Text style={styles.subheading}>Next of Kin</Text>
              <View style={[styles.line, { flex: 1, marginLeft: 5, marginTop: 20 }]}></View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Name (optional)</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Name"
                  value={formData.nextToKin.name}
                  onChangeText={(text) => handleChange('nextToKin.name', text)}
                />
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Relation</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Relation"
                  value={formData.nextToKin.relation}
                  onChangeText={(text) => handleChange('nextToKin.relation', text)}
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Contact</Text>
                <TextInput
                  style={{ ...styles.input, width: screenWidth < MOBILE_VIEW_WIDTH ? '100%' : '48.5%' }}
                  placeholder="Contact"
                  value={formData.nextToKin.contact}
                  onChangeText={(text) => handleChange('nextToKin.contact', text)}
                />
              </View>
            </View>
            {screenWidth < MOBILE_VIEW_WIDTH && (
              <TouchableOpacity style={{ ...styles.button, marginBottom: 10 }} onPress={handleSubmit}>
                <Text style={styles.buttonText}>Save Changes</Text>
              </TouchableOpacity>
            )}
          </View>
        </ScrollView>
      </View>

      <Dialog
        message={toastMessage}
        isDialogVisible={showToast}
        handleDialogConfirm={() => setShowToast(false)}
        cancelText="Close"
      />

      {
        showLoader && (
          <Loader />
        )
      }
    </div>
  );
};

const styles = StyleSheetRW.create(() => ({
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
  heading: {
    fontFamily: "Outfit",
    fontSize: 32,
    fontWeight: 'bold',
    textAlign: "left",
    color: "#2F4858",
  },
  subheading: {
    fontFamily: 'Outfit',
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2F4858',
    marginTop: 10,
  },
  form: {
    width: '100%',
    height: '100%',
    marginTop: 20,
  },
  row: {
    justifyContent: 'space-between',
    marginBottom: 10,
    gap: 20
  },
  inputContainer: {
    flex: 1,
    marginRight: 5,
  },
  label: {
    fontFamily: 'Outfit',
    fontSize: 14,
    fontWeight: '600',
    lineHeight: 17.64,
    textAlign: 'left',
    marginBottom: 5,
    color: '#333333',
  },
  input: {
    height: 50,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: '#0000000D',
    marginTop: 3,
    placeholderTextColor: '#333333',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    backgroundColor: '#2F4858',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 100,
  },
  buttonText: {
    color: 'white',
    fontWeight: "300",
    textAlign: "center",
  },
  line: {
    borderBottomWidth: 1,
    borderColor: '#2F4858',
    marginBottom: 10,
  },
}))

export default AdminEditUserProfileScreen;